import { render, staticRenderFns } from "./PalletTableRow.vue?vue&type=template&id=464035bb&scoped=true&"
import script from "./PalletTableRow.vue?vue&type=script&lang=js&"
export * from "./PalletTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464035bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464035bb')) {
      api.createRecord('464035bb', component.options)
    } else {
      api.reload('464035bb', component.options)
    }
    module.hot.accept("./PalletTableRow.vue?vue&type=template&id=464035bb&scoped=true&", function () {
      api.rerender('464035bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/pallet/PalletTableRow.vue"
export default component.exports